import React from 'react'

const LoadingInner = props => {
  return (
    <div className="loaderInner">
      <div className="loaderInner__container">
        <div className="loader__container"><div className="loader centerLoader"><span></span></div></div>
      </div>
    </div>
  )
}

export default LoadingInner